/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Fri May 06 2022
*  File : SDKClient.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";
import { SdkModuleAutoloadManager } from "@api-commons/modularization/SdkModuleAutoloadManager.js";
import { ClientSdk7 } from "@api-commons/sdk/ClientSdk7.js";

export const SdkClient = (cfg: PropertyConfig, autoloader: SdkModuleAutoloadManager) => {
    const cli = new ClientSdk7(cfg, {}, autoloader);
    window['FanpageSdk'] = cli;
    return cli;
};